import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { fadeUp, viewportOnce } from "@/lib/motion";

export const Reset = () => {
  const { t } = useLang();
  return (
    <section
      id="reset"
      data-testid="reset-section"
      className="relative py-28 md:py-40 bg-ivory text-forest"
    >
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        variants={fadeUp}
        className="max-w-3xl mx-auto px-6 md:px-12 text-center"
      >
        <p className="overline text-bronze mb-8">{t.reset.eyebrow}</p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.1] tracking-tight">
          {t.reset.title}
        </h2>
        <div className="mt-10 text-base md:text-lg leading-relaxed text-forest/80 space-y-6 text-left md:text-center">
          {t.reset.body.split("\n\n").map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
        <div
          className="mt-12 mx-auto w-12 h-[2px]"
          style={{ background: "var(--yz-bronze)" }}
          aria-hidden="true"
        />
        <p className="mt-12 font-serif italic text-2xl md:text-3xl lg:text-4xl text-forest leading-snug">
          &ldquo;{t.reset.closing}&rdquo;
        </p>
      </motion.div>
    </section>
  );
};
